import Vue from 'vue';
import VueRouter from 'vue-router';

import PageA from './views/a';
import PageB from './views/b';
import PageC from './views/c';

Vue.use(VueRouter);

export default new VueRouter({
  routes: [
    {
      path: '/a',
      name: PageA.name,
      component: PageA,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/b',
      name: PageB.name,
      component: PageB
    },
    {
      path: '/c',
      name: PageC.name,
      component: PageC
    },
    {
      path: '/*',
      redirect: { name: PageA.name }
    }
  ]
});